import ModelPortfolio from '@advisor/models/store/investmentModel/ModelPortolio';

export default class InvestmentModel {
  constructor() {
    this.modelPortfolios = [];
    this.modelPortfolioData = new ModelPortfolio();
    this.defaultModelPortfolioData = new ModelPortfolio();
    this.glidePathFrameworks = [];
    this.glidePathFrameworkTypes = [];
    this.modelPortfolioComposites = {};
    this.sleevesList = [];
    this.assetManagers = [];
    this.filteredManagers = [];
    this.glidePathFrameworkDetails = {
      ...InvestmentModel.getNewGlidePathFramework(),
    };
    this.sleeveDetails = {};
    this.sleevesTickers = [];
    this.newGlidePathFramework = {
      ...InvestmentModel.getNewGlidePathFramework(),
    };
    this.selects = {
      tickers: [],
      composites: [],
      tickersAll: [],
      taxSettings: [],
    };
  }

  static getNewGlidePathFramework() {
    return {
      modelName: '',
      description: '',
      assetManagerName: 'Custom',
      gpId: '',
      lastUpdate: '',
      portfolio: {
        conservative: {
          start: {
            id: null,
            name: '',
          },
          end: {
            id: null,
            name: '',
          },
        },
        aggressive: {
          start: {
            id: null,
            name: '',
          },
          end: {
            id: null,
            name: '',
          },
        },
      },
    };
  }

  static fetchModelPortfolios(arrModelPortfolios) {
    return arrModelPortfolios.map((objModelPortfolio) => {
      const modelPortfolio = new ModelPortfolio();

      return Object.assign(modelPortfolio, objModelPortfolio);
    });
  }

  static getInvestmentModelTabs() {
    const investmentModelTabs = new Map();

    investmentModelTabs.set('portfolios', {
      id: 'modelId',
      name: 'modelName',
      label: 'Model Portfolios',
      value: 'portfolios',
      singularName: 'Model Portfolio',
      storeList: 'modelPortfolios',
      detailsRouteName: 'ModelPortfolioDetails',
      fetchAction: 'getModelPortfolios',
      searchWith: 'modelName',
      addButtonName: 'Model',
    });

    InvestmentModel.setGlidePathStep(investmentModelTabs);

    investmentModelTabs.set('sleeves', {
      id: 'sleeveId',
      name: 'sleeveName',
      label: 'Sleeves',
      singularName: 'Sleeve',
      value: 'sleeves',
      storeList: 'sleevesList',
      detailsRouteName: 'SleeveDetails',
      fetchAction: 'fetchSleeves',
      searchWith: 'sleeveName',
      addButtonName: 'Sleeve',
    });

    return investmentModelTabs;
  }

  static setGlidePathStep(investmentModelTabs) {
    investmentModelTabs.set('glidepath', {
      id: 'modelId',
      name: 'modelName',
      label: 'Glide Path Framework',
      singularName: 'Glide Path Framework',
      value: 'glidepath',
      storeList: 'glidePathFrameworks',
      detailsRouteName: 'GlidepathDetails',
      fetchAction: 'getGlidePathFrameworks',
      searchWith: 'modelName',
      addButtonName: 'Framework',
    });
  }
}
